'use client';
import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import ProductTabs from '../../components/blocks/product_tabs/ProductTabs';
import Price from '../../components/price/Price';
import { MODAL_TYPES, useModal } from '../../components/modal/ModalProvider';
import Link from 'next/link';

export default function BundleOfferModalWrapper({
  isOpen,
  onClose,
  product,
  productTabs,
  pricingDetailsData,
  index
}) {
  const modalRef = useRef(null);
  const { modalUtils, getCloseButton } = useModal();

  useEffect(() => {
    if (isOpen && modalRef?.current) {
      modalRef?.current.focus();
    }
  }, [isOpen]);

  if (!isOpen || !product) return null;

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.bundleOffer,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.crossSell.green,
    children: (
      <div ref={modalRef} tabIndex={-1}>
        {getCloseButton(MODAL_TYPES.bundleOffer, onClose)}
        <div className="sm:flex">
          <div className="relative mx-auto h-[135px] w-[180px] max-w-full sm:mx-0 lg:h-[165px] lg:w-[220px]">
            <Image
              src={`${product?.thumbnailImage}?format=pjpg&auto=webp&disable=upscale`}
              alt={product?.product?.title?.replace(/\.[^/.]+$/, '')}
              fill={true}
            />
          </div>
          <div className="ml-0 pt-5 sm:ml-8 sm:w-[324px] sm:pt-0 lg:ml-10 lg:w-[347px]">
            <div className="h4 text-white">{product?.product?.title}</div>
            <div className="body-s text-dawn-grey">
              {product?.variant?.title}
            </div>
            <Price
              price={parseFloat(
                (product?.variant?.price?.amount || 0) -
                  (product?.discount || 0)
              )}
              compareAtPrice={product?.variant?.compareAtPrice?.amount}
              priceClassOverride="price-r text-[#FF8347]!"
              crossedPriceClassOverride="price-r-crossed text-dawn-grey!"
            />
            {pricingDetailsData?.price_details_link && (
              <Link
                href={pricingDetailsData?.price_details_link.href}
                className="body-s text-dawn-grey mt-1 flex w-fit grow-0 cursor-pointer items-center underline"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${pricingDetailsData?.price_details_link.title} - Link opens in a new tab`}
              >
                <span className="mr-1">
                  {pricingDetailsData?.price_details_link.title}
                </span>
                <span className="sr-only">Link opens in a new tab</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 2"
                  viewBox="0 0 12 12"
                  width="12"
                  height="12"
                  aria-hidden="true"
                >
                  <g data-name="Layer 1">
                    <path
                      d="M4.152 7.005 10.685.5M7.056.5h3.63v3.614"
                      style={{
                        fill: 'none',
                        stroke: '#a19f9b',
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round'
                      }}
                    />
                    <path
                      d="M4.674 2.345H1.5a1 1 0 0 0-1 1v6.348a1 1 0 0 0 1 1h6.348a1 1 0 0 0 1-1V6.519"
                      style={{
                        fill: 'none',
                        stroke: '#a19f9b',
                        strokeLinecap: 'round'
                      }}
                    />
                  </g>
                </svg>
              </Link>
            )}

            <div className="pt-2 pb-6">
              <ProductTabs
                key={`modal-${index}`}
                block={productTabs}
                modalIndex={`${index}`}
              />
            </div>
          </div>
        </div>
      </div>
    )
  });
}
